import useSubscriptionPermission from "@/hooks/useSubscriptionPermission";
import DetailsPanel from "@/src/recipes/components/RecipeHero/DetailsPanel";
import MediaPanelWrapper from "@/src/recipes/components/RecipeHero/MediaPanelWrapper";
import clsx from "clsx";
import { observer } from "mobx-react";

const RecipeHero = ({
  entry,
  first = false,
  totalNotesIncludingReplies = 0,
  ratingValue = 0,
  theme = "light" as const,
  nextRecipeHref = null,
  prevRecipeHref = null,
  mealPlan = null,
}: {
  entry: any;
  first?: boolean;
  totalNotesIncludingReplies: number;
  ratingValue: number;
  theme?: "light" | "dark";
  nextRecipeHref?: string | null;
  prevRecipeHref?: string | null;
  mealPlan?: any;
}) => {
  const { contentIsRestricted, subscriptionPermission } =
    useSubscriptionPermission(entry);

  return (
    <div
      className={clsx("RecipeHero", "relative h-full print:bg-white", {
        "bg-white text-zinc-950 lg:border-b": theme === "light",
        "bg-zinc-900 text-zinc-50": theme === "dark",
      })}
    >
      <div
        className={clsx(
          "RecipeHero__content",
          "mx-auto flex h-full flex-col overflow-hidden md:max-h-screen md:flex-row print:!flex-col"
        )}
      >
        <div
          className={clsx(
            "RecipeHero__detailsContainer",
            "relative order-2 flex w-full md:order-1 md:w-1/2 md:border-r print:!order-1 print:!w-full",
            {
              "border-zinc-200": theme === "light",
              "border-zinc-700": theme === "dark",
            }
          )}
        >
          <DetailsPanel
            entry={entry}
            contentIsRestricted={contentIsRestricted}
            isMobPlusMember={subscriptionPermission.isMobPlusMember}
            ratingValue={ratingValue}
            totalNotesIncludingReplies={totalNotesIncludingReplies}
            theme={theme}
            nextRecipeHref={nextRecipeHref}
            prevRecipeHref={prevRecipeHref}
            mealPlan={mealPlan}
          />
        </div>
        <div
          className={clsx(
            "RecipeHero__mediaContainer print:hidden",
            "relative order-1 flex w-full md:order-2 md:w-1/2 md:p-8 lg:p-12 print:!order-2 print:!w-full print:!p-0"
          )}
        >
          <MediaPanelWrapper
            entry={entry}
            contentIsRestricted={contentIsRestricted}
            isMobPlusMember={subscriptionPermission.isMobPlusMember}
            first={first}
          />
        </div>
      </div>
    </div>
  );
};

export default observer(RecipeHero);
